import { imgSrc, imgSrcSet } from "@/data/images";

/**
 * Responsive image. Serves AVIF with a JPEG fallback, reserves layout space via
 * intrinsic width/height, and lazy-loads by default.
 *
 * Pass `priority` for above-the-fold imagery (the hero) so it loads eagerly and
 * is fetched at high priority — everything else should stay lazy.
 *
 * `sizes` should describe the rendered width at each breakpoint so the browser
 * can pick the smallest adequate variant. Defaults to full viewport width.
 */
export const Picture = ({
  img,
  alt = "",
  className = "",
  sizes = "100vw",
  priority = false,
  ...rest
}) => (
  <picture>
    <source type="image/avif" srcSet={imgSrcSet(img, "avif")} sizes={sizes} />
    <source type="image/jpeg" srcSet={imgSrcSet(img, "jpg")} sizes={sizes} />
    <img
      src={imgSrc(img)}
      alt={alt}
      width={img.w}
      height={img.h}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : undefined}
      decoding={priority ? "sync" : "async"}
      className={className}
      {...rest}
    />
  </picture>
);
